module.exports = __webpack_public_path__ + "static/media/swieta24.cb1791bd.jpg";